import Badge from '@/storybook/components/Badge/Badge';
import { SelectItem } from '@/types/ui';

/**
 * In-dropdown badge for cascading filter items:
 * - selected + enabled → blue badge (result count when known)
 * - selected + disabled → grey badge (zero results)
 * - unselected → no badge
 */
export function getCascadingItemBadge<T>(option: SelectItem<T>, isSelected: boolean): React.ReactNode {
  if (!isSelected) return null;

  const isDisabled = option.disabled === true;
  const color = isDisabled ? 'grey' : 'blue';
  const label = isDisabled ? '0' : option.count != null ? String(option.count) : undefined;

  if (label == null) return null;

  return (
    <Badge size="S" variant="light" color={color} data-testid="cascadingItemBadge">
      {label}
    </Badge>
  );
}
